module.exports = __webpack_public_path__ + "img/study.5ded3256.jpg";